import { SxProps, Theme } from '@mui/material/styles';

export const cardSx: SxProps<Theme> = {
  backgroundColor: 'background.paper',
  color: 'text.primary',
  border: 'none',
  width: '100%',
  height: '100%',
};
